<h4 class="mt-3">{{intent.title}}</h4>
<div class="font-semibold">{{intent.subtitle}}</div>

<ng-container *ngIf="bookingRequests">
    <div *ngFor="let position of intent.positions; let index= index">
        <div class=" mt-4 mb-4  w-full">
            <div class="flex flex-column w-full p-3" style="background-color: var(--surface-card);">
                <div class="text-lg">{{position.title}}</div>
                <div *ngIf="position.subtitle!=null" class="mt-2">{{position.subtitle}}</div>
                <div class="flex align-items-center mt-3">
                    <div class="flex-1">
                        <p-select [options]="walletElements" [(ngModel)]="bookingRequests[index].walletElement"
                            optionDisabled="disabled" emptyMessage="No tickets found"
                            i18n-emptyMessage="@@payment-booking-no-ticket-found"
                            (onChange)="onTicketSelected(index,$event)" optionValue="element.id" [showClear]="true"
                            placeholder="Please select a ticket"
                            i18n-placeholder="@@payment-booking.select-placeholder" [style]="{'width':'100%'}"
                            [autoDisplayFirst]="false">

                            <ng-template #selectedItem let-entry>
                                <ng-container *ngIf="entry">
                                    <div class="flex align-items-center gap-2">
                                        <img [src]="entry.element.product.image?.url" style="width: 25px" />
                                        <div class="ml-1">{{ entry.element.product.name }}</div>
                                    </div>
                                    <div *ngIf="entry && entry.element.product.type ==='MULTI_TICKET'" class="text-sm"
                                        style="margin-left: 30px">
                                        noch {{capacityPerWalletElement[entry.element.id]}} Einheiten verfügbar
                                    </div>
                                    <div *ngIf="entry &&  entry.element.product.type ==='SEASON_TICKET'" class="text-sm"
                                        style="margin-left: 30px">
                                        gültig bis {{entry.element.validTo | date:'shortDate'}}
                                    </div>
                                </ng-container>
                            </ng-template>
                            <ng-template let-entry #item>
                                <ng-container *ngIf="entry">
                                    <div class="flex align-items-center gap-2">
                                        <img [src]="entry.element.product.image?.url" style="width: 25px" />
                                        <div class="ml-1">{{ entry.element.product.name }}</div>
                                    </div>
                                    <div *ngIf="entry &&  entry.element.product.type ==='MULTI_TICKET'" class="text-sm"
                                        style="margin-left: 30px">
                                        noch {{capacityPerWalletElement[entry.element.id]}} Einheiten verfügbar
                                    </div>
                                    <div *ngIf="entry &&  entry.element.product.type ==='SEASON_TICKET'" class="text-sm"
                                        style="margin-left: 30px">
                                        gültig bis {{entry.element.validTo | date:'shortDate'}}
                                    </div>
                                </ng-container>
                            </ng-template>
                        </p-select>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="flex justify-content-between">
        <p-button label="Buy" i18n-label="@@payment-booking.buttons.buy"
            (onClick)="goto.emit('shop')" severity="secondary"></p-button>
        <p-button label="Complete booking" i18n-label="@@payment-booking.buttons.complete"
             *ngIf="allRequetsFilled" (onClick)="book.emit(bookingRequests)" severity="secondary"></p-button>
    </div>
</ng-container>